export default class AIFormatTools {
  static parseAttributes(attributes) {
    // Return the parsed attributes
    return attributes.reduce((acc, attr) => {
      // If the attribute value is not a string
      if (attr.value.type !== 'string') {
        // Return the accumulator
        return acc;
      }
      // Get the value of the attribute
      let value = attr.value.data;
      // If the attribute value is not plain
      if (!attr.value.plain) {
        // Parse the attribute value
        const doc = new DOMParser().parseFromString(
          `<p>${attr.value.data}</p>`, // In case it's not in <p></p> tags.
          'text/xml'
        );
        // Get the text content of the document
        value = doc.firstChild.textContent;
      }
      // Add the attribute to the accumulator
      acc[attr.name] = value;
      // Return the accumulator
      return acc;
    }, {});
  }

  static addParagraphTags(texts) {
    return texts.map(text => {
      text = text.trim();
      if (!text.startsWith('<p>')) {
        text = `<p>${text}`;
      }
      if (!text.endsWith('</p>')) {
        text += '</p>';
      }
      return text;
    });
  }

  static replaceMarkdownWithHtml(text) {
    return text
      .replace(/(#+\s?)(.*?)(\n|<br>)/g, '<b>$2</b><br>') // Replace headers with <b> tags and add <br> for new lines
      .replace(/(\*\*|__)(.+?)\1/g, '<b>$2</b>') // Replace bold markdown with <b> tags
      .replace(/(\*|_)(.+?)\1/g, '<i>$2</i>') // Replace italic markdown with <i> tags
      .replace(/~~(.*?)~~/g, '<u>$1</u>') // Replace strikethrough markdown with <u> tags
      .replace(/\n/g, '<br>') // Replace newlines with <br> tags
      .replace(/```/g, '');
  }

  static removeSpanTags(text) {
    return text.replace(/<span.*?>(.*?)<\/span>/g, '$1');
  }

  static filterMentions(texts, json, type) {
    // Extract ids and labels from the JSON input
    const ids = json.map(obj => obj.id);
    const labels = json.map(obj => obj.name);

    return texts.map(text => {
      let regex = '';
      let replacer = null;
      if (type === 'component') {
        // Regular expression to match <span> elements with the specified format
        regex =
          /<span class="mention-component mention" data-id="(.*?)" data-label="(.*?)" data-type="component">(.*?)<\/span>/g;
        // Replace function
        replacer = (match, id, label, name) => {
          // Check if the id and name are valid and at the same index
          const index = ids.indexOf(id);
          if (index !== -1 && labels[index] === label && label === name) {
            // If valid, return the original match
            return match;
          }
          // If not valid, return just the name text
          return name;
        };
      } else if (type === 'element') {
        // Regular expression to match <span> elements with the specified format
        regex =
          /<span class="mention-element mention" data-id="(.*?)" data-label="(.*?)" data-type="element">(.*?)<\/span>/g;
        // Replace function
        replacer = (match, id, label, name) => {
          // Check if the id and name are valid and at the same index
          const index = ids.indexOf(id);
          if (index !== -1 && labels[index] === label && label === name) {
            // If valid, return the original match
            return match;
          }
          // If not valid, return just the name text
          return name;
        };
      } else if (type === 'board') {
        // Regular expression to match <span> elements with the specified format
        regex =
          /<span class="mention-board mention" data-id="(.*?)" data-type="board">(.*?)<\/span>/g;
        // Replace function
        replacer = (match, id, name) => {
          // Check if the id and name are valid and at the same index
          const index = ids.indexOf(id);
          if (index !== -1 && labels[index] === name) {
            // If valid, return the original match
            return match;
          }
          // If not valid, return just the name text
          return name;
        };
      }
      // Replace invalid <span> elements in the text
      const result = text.replace(regex, replacer);
      return result;
    });
  }

  static removeBoardMentions = text => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    const boardSpans = tempDiv.querySelectorAll('span[data-type="board"]');
    boardSpans.forEach(span => {
      const name = span.innerText;
      span.outerHTML = name;
    });
    return tempDiv.innerHTML;
  };

  static isTextEmpty = (...values) => {
    return values.every(value => {
      if (!value) return true;
      const trimmedValue = value.trim().replace(/^<p>|<\/p>$/g, '');
      return trimmedValue === '';
    });
  };

  static getComponentMentionIDs = text => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    return Array.from(
      tempDiv.getElementsByClassName('mention mention-component')
    ).map(comp => comp.getAttribute('data-id'));
  };

  /**
   * This function is used to remove the <p></p> tags from the start and end of the text
   * @param {*} text the text to be formatted
   * @returns
   */
  static removeTags = text => {
    if (text) {
      text = text.trim(); // Remove spaces from the outer part
      text = text.replace(/^<p>|<\/p>$/g, ''); // Remove <p></p> tags from the start and end
      return text;
    }
    return '';
  };
}
